import dataService from '../app.service'

export default {
  login(credentials) {
    return dataService.post('/users/sessions?v2', credentials)
  },
  createAccount(credentials) {
    return dataService.post('/users/new?v2', credentials)
  },
  isActiveSubscriber(id) {
    return dataService.get(`/subscriptions/bundles/users/${id}/isAllAccess`)
  },
  logout() {
    return dataService.delete('/users/sessions/me')
  },
  resetPassword(data) {
    return dataService.post('/users/reset-password', data)
  },
  resetPasswordToken(data) {
    return dataService.post('/users/reset-password/tokens', data)
  },
  isExistingUser(email) {
    return dataService.get(`/public/user-email-exists/${email}`)
  },
}
